import React from 'react';
import styles from './index.module.scss';

interface SeoCopyRightProps {
  className?: string;
  style?: React.CSSProperties;
}

/**
 * SEO 版权信息组件，支持通过 className 和 style 自定义样式
 */
export default function SeoCopyRight({ className, style }: SeoCopyRightProps) {
  return (
    <div
      className={`${styles['copy-right']}${className ? ` ${className}` : ''}`}
      style={style}
    >
      © 2026 Meitu. Xiamen Meitu Technology Co., Ltd. All Rights Reserved.
    </div>
  );
}
